import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {
  // Value of the progress bar
  @Input() value: number;

  // Additional CSS class for the progress bar
  @Input() bgClass: string;

  // Whether the progress bar should be striped
  @Input() striped: boolean;

  // Whether the progress bar should be animated
  @Input() animated: boolean;

  // Height of the progress bar
  @Input() height: string;
}

